import { nanoid } from 'nanoid';
import { useQueryState } from 'nuqs';
import { useCallback } from 'react';

import { type QueryStateSchema, queryParam, queryStateParser } from './queryStateParser';

const QS_TYPE: QueryStateSchema['type'] = 'anvilCastEditor';

type OpenAnvilCastEditorArgs = {
  castEid: string;
  embedUrl: string;
  title: string;
  creatorId: string;
};

type OpenAnvilCastEditorForEditArgs = OpenAnvilCastEditorArgs & {
  formRequestTemplateId: string;
  formRequestTemplateSlug: string;
};

export const useOpenAnvilCastEditorPane = (): ((args: OpenAnvilCastEditorArgs) => void) => {
  const [, setState] = useQueryState(queryParam, queryStateParser);

  return useCallback(
    ({ castEid, embedUrl, title, creatorId }: OpenAnvilCastEditorArgs) => {
      setState((prevState) => [
        ...(prevState || []),
        {
          creatorId,
          embedUrl,
          id: castEid,
          key: nanoid(),
          mode: 'create' as const,
          title,
          type: QS_TYPE,
        },
      ]);
    },
    [setState],
  );
};

export const useOpenAnvilCastEditorPaneForEdit = (): ((args: OpenAnvilCastEditorForEditArgs) => void) => {
  const [, setState] = useQueryState(queryParam, queryStateParser);

  return useCallback(
    ({
      castEid,
      embedUrl,
      title,
      creatorId,
      formRequestTemplateId,
      formRequestTemplateSlug,
    }: OpenAnvilCastEditorForEditArgs) => {
      setState((prevState) => [
        ...(prevState || []),
        {
          creatorId,
          embedUrl,
          formRequestTemplateId,
          formRequestTemplateSlug,
          id: castEid,
          key: nanoid(),
          mode: 'edit' as const,
          title,
          type: QS_TYPE,
        },
      ]);
    },
    [setState],
  );
};
